import { RiArrowLeftRightLine } from "@remixicon/react";
import { cn } from "@/lib/utils";

export interface LayoutToggleProps {
	isHorizontal: boolean;
	onClick: () => void;
	className?: string;
}

export const LayoutToggle = function LayoutToggleComponent({
	isHorizontal,
	onClick,
	className,
}: LayoutToggleProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			className={cn(
				"flex h-9 w-9 items-center justify-center rounded-xl transition-colors active:scale-[0.99]",
				isHorizontal
					? "bg-primary text-primary-foreground"
					: "border border-input bg-background text-foreground hover:bg-accent",
				className,
			)}
			title={
				isHorizontal
					? "Switch to vertical layout"
					: "Switch to horizontal layout"
			}
		>
			<RiArrowLeftRightLine
				className={cn("h-4 w-4", isHorizontal ? "" : "rotate-90 transform")}
			/>
		</button>
	);
};
